import React from 'react';
import { createComponent } from '@lit/react';
import { IxField as LitComp } from '../IxField.js';

customElements.define('ix-field', LitComp);

export const IxField = createComponent({
  tagName: 'ix-field-react',
  elementClass: LitComp,
  react: React,
});
